import React, { useState } from 'react';
import MUIDataTable from 'mui-datatables';

import AutoAllocationLogs from './AutoAllocationLogs';
import LoadingPageText from '../../../common/Loading/LoadingPageText';
import { useAutoAllocationGroups } from '../../../../actions/areas/planner/fetchHooks';
import eventHandlers from './autoAllocateHandler';
import tableSettings from './tableSettings';

export default function AutoAllocationContent({ orgUnitId, selectedDate, logType }) {
  const [state, setState] = useState({
    forceReload: false,
    openSidePanel: false,
    selectedGroup: null,
  });

  const model = {
    OrgUnitId: orgUnitId,
    SelectedDate: selectedDate,
    Period: 0, // isNightMode ? 2 : 1,
    Status: logType,
  };
  const { data, isDataLoading } = useAutoAllocationGroups(model, state.forceReload);

  const events = eventHandlers(state, setState);
  const settings = tableSettings({ eventHandlers: events });

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>Wait a moment while we gather AutoAllocation info...</LoadingPageText>;

  return (
    <div className="page-content-wrapper">
      <MUIDataTable title={settings.name} data={data} columns={settings.columns} options={settings.options} />
      {state.openSidePanel && <AutoAllocationLogs events={events} selectedGroup={state.selectedGroup} />}
    </div>
  );
}
